import { render, staticRenderFns } from "./_manage-cookie-text-template.vue?vue&type=template&id=521d6e20"
import script from "./_manage-cookie-text-template.vue?vue&type=script&lang=js"
export * from "./_manage-cookie-text-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports